import {Component, OnInit} from '@angular/core';
import {ICON_TYPE, LaunchDialogService} from "@spartacus/storefront";
import {QuickStockAdapterImpl} from "../../core/adapters/quick-stock.adapter";
import {Observable, of} from "rxjs";
import {Channel} from "../../core/interfaces/channel";
import {QuickStockNotification} from "../../core/interfaces/QuickStockNotification";
import {GlobalMessageService, GlobalMessageType} from "@spartacus/core";

@Component({
  selector: 'app-gonvarri-quick-stock-notification',
  standalone: false,
  templateUrl: './gonvarri-quick-stock-notification.component.html',
  styleUrl: './gonvarri-quick-stock-notification.component.scss'
})
export class GonvarriQuickStockNotificationComponent implements OnInit {

  protected readonly ICON_TYPE = ICON_TYPE;

  productCode: string = "";
  receiveOnEmail: boolean = false;
  quickStockNotification$: Observable<QuickStockNotification> = of()

  constructor(
    protected launchDialogService: LaunchDialogService,
    protected quickStockAdapter: QuickStockAdapterImpl,
    protected globalMessagesService: GlobalMessageService,
  ) {}

  ngOnInit() {
    this.launchDialogService.data$.subscribe((data) => {
      this.productCode = data.productCode;
      if(this.productCode) {
        this.quickStockAdapter.getStockNotification(this.productCode).subscribe((data: QuickStockNotification[]) => {
          this.quickStockNotification$ = of(data[0]);
        });
      }
    });
  }

  onSubmitForm(): void {
    this.quickStockNotification$.subscribe(quickStockNotification => {
      if(!!quickStockNotification.removeUrl) {
        this.unsubscribeOnEmail()
      }else {
        this.subscribeOnEmail(quickStockNotification);
      }
    });
  }

  unsubscribeOnEmail(): void {
    this.quickStockAdapter.removeStockNotification(this.productCode)
      .subscribe(response => {
        this.globalMessagesService.add({
          key: "quickstock.notification.updated"
        }, GlobalMessageType.MSG_TYPE_INFO)
        this.closeModal();
      });
  }

  subscribeOnEmail(quickStockNotification: QuickStockNotification): void {
    this.quickStockAdapter.addStockNotification(this.productCode, quickStockNotification.stockNotificationForm.channels.filter(channel => channel.visible).map(channel => ({...channel, enabled: this.receiveOnEmail})))
      .subscribe(response=> {
        this.globalMessagesService.add({
          key: "quickstock.notification.updated"
        }, GlobalMessageType.MSG_TYPE_INFO)
        this.closeModal();
      });
  }

  closeModal(): void {
    this.launchDialogService.closeDialog('User did a request for closing the modal');
  }

}
